
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 144 144","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M89.548 54c-.36-7.5-4.32-12.6-15-12.6-2.4 0-4.62.3-6.54.78l-9.06-9.06c2.1-.9 4.26-1.68 6.6-2.16V18h18v13.14c12.54 3.06 18.84 12.54 19.26 22.86h-13.26zM23.91 31.99l8.46-8.46 87.72 87.719-8.46 8.46-13.32-13.32c-3.78 3.42-9 5.64-14.76 6.72v12.9h-18v-13.02c-11.52-2.46-21.36-9.84-22.08-22.98h13.2c.66 7.08 5.52 12.6 17.88 12.6 8.22 0 12.48-2.52 14.52-5.46L68.01 76.09c-14.1-4.14-23.46-10.98-23.46-23.46L23.91 31.99z","fill":"#ABABAB"}})])
          )
        }
      }
    